import React from 'react';
import './botInfoCard.scss';

interface BotInfoCardProps {
  message: string;
}

const BotInfoCard: React.FC<BotInfoCardProps> = ({ message }) => {
  return (
    <div className="bot-info-card">
      <div className="bot-info-text">{message}</div>
    </div>
  );
};

export default BotInfoCard;